export default __webpack_public_path__ + "static/media/placeholder_business05-it-web.2e3f8b95.png";